import type { FaireProductEntity } from "../../entity_types/product";

export const p_exqcmd4wop: FaireProductEntity = {
  token: "p_exqcmd4wop",
  type: "product",
  name: "Medium Checkerboard Acetate Daisy Earrings",
  brandToken: "b_2qwgasr6b7",
  brandName: "Cities in Dust Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/aaf2a69699de18461f30ed04d9cb6fbbe48f326af794a5bd5394898bf0be3c8f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e952b949cc3b5aff11d221fdc2e3f8bf2cbf0b86f8b12082f5f8ab7054a3b08.jpeg",
    "https://cdn.faire.com/fastly/7ac7c2cf3ba0c9fd4649deace6a05569b048ec130862158d86730b4717bba6cc.jpeg",
  ],
  priceDollars: 13,
  description:
    "1.1 inch small earring with surgical steel posts. Very light-weight. ",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:45.513Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
